import React from 'react';

const Stars = ({ height = '1em', color = '#FFB741' }) => (
  <svg height={height} viewBox="0 0 37 30" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g
        id="New-Overall-Winner"
        transform="translate(-1046 -913)"
        fill={color}
        fillRule="nonzero"
      >
        <g id="Group-4" transform="translate(758 434)">
          <g id="Group-6">
            <g id="Group-4-Copy" transform="translate(76 458)">
              <g id="Group-3" transform="translate(35 18)">
                <g id="43973" transform="translate(177 3)">
                  <path
                    d="M11.0672253,28.7670921 C11.3699805,30.1041064 12.4013033,30.3995899 13.3706412,29.4272218 L19.3168957,23.4628056 L22.1632503,23.5242402 L22.7338248,19.1811519 L19.5145176,16.2651516 C18.9571092,15.7602319 18.7305479,15.1264685 18.8926474,14.5263447 C19.0548121,13.9262209 19.5702454,13.491373 20.3067649,13.3336952 L24.5451414,12.4250996 L26.5108663,8.5323801 C26.5555789,8.44379999 26.604463,8.36067495 26.6564756,8.28203087 L27.7713575,5.97031062 C28.3673517,4.73486476 27.7579959,3.95771061 26.4104911,4.23390653 L17.9780596,5.96381647 L11.2836187,0.46262753 C10.2223788,-0.409406057 9.23531229,-0.0124840075 9.07875301,1.34907811 L8.09123025,9.9388817 L0.815851387,14.5243315 C-0.346676227,15.2570007 -0.255947452,16.269113 1.01849202,16.7848129 L9.0934834,20.0518217 L11.0672253,28.7670921 Z"
                    id="Shape"
                  />
                  <path
                    d="M36.2170532,14.7958849 L36.2169974,14.7958768 L31.1669032,14.0586119 L31.0449024,13.855705 L28.5676152,9.73558018 C28.4638837,9.56301116 28.3734465,9.5 28.3243091,9.5 C28.277243,9.5 28.1914661,9.56482641 28.0961372,9.74900783 L25.7808228,14.2233312 L25.5482817,14.271959 L24.4385752,14.504015 L20.7873993,15.2679437 C20.426166,15.3434811 20.4162754,15.3792048 20.6811665,15.6133566 L24.5289269,19.0144593 L24.4933132,19.279009 L23.8618431,23.9697673 L23.8350594,24.1689948 C23.7985004,24.4407004 23.8399654,24.5 23.9473965,24.5 C24.0189644,24.5 24.1139676,24.4770687 24.2265369,24.4259804 L26.2392274,23.5127839 L28.741481,22.3774232 L28.93631,22.4516967 L29.6477233,22.7229044 L33.3791582,24.1460064 C33.4848645,24.1862659 33.5737752,24.2045136 33.641355,24.2045136 C33.7444222,24.2045136 33.7650578,24.1706028 33.6986481,23.9013725 L32.4325676,18.7742943 L32.6446377,18.574048 L36.3284186,15.0956543 C36.5801133,14.8579256 36.5769629,14.8483868 36.2170532,14.7958849 Z"
                    id="Shape"
                    stroke="#FFF"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Stars;
